import { render } from "./WhatOur.vue?vue&type=template&id=0aef74ba&lang=true"
import script from "./WhatOur.vue?vue&type=script&lang=js"
export * from "./WhatOur.vue?vue&type=script&lang=js"

import "./WhatOur.vue?vue&type=style&index=0&id=0aef74ba&lang=scss"

import exportComponent from "C:\\Users\\MrBin\\Desktop\\Front\\vac2\\VAC\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__